import { h } from "preact";
import { PoweredBy3Play } from "./PoweredBy3Play";

const Footer = () => (
  <div class="Footer">
    <PoweredBy3Play />
  </div>
);
export default Footer;
